import type { FC, SVGProps } from 'react';

const FirstOfMonthCalendar: FC<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      className={className}
      viewBox="20 3 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_9558_145)">
        <path
          d="M42.9246 18.5715C42.9246 19.5395 42.9982 22.1295 42.8892 22.8064C42.5371 24.9944 39.1097 25.7617 37.6238 25.9014C35.4656 25.9014 35.519 25.5548 35.0428 25.5548C34.229 25.5548 33.0261 25.7409 32.2478 25.7409C31.4694 25.7409 31.0095 25.6478 29.2051 25.7409C27.4007 25.834 25.0595 25.5994 24.244 23.9233C23.6297 22.6607 24.0671 19.7349 23.9256 18.3853C23.7841 17.0358 23.8902 15.0346 23.8902 13.4524C23.8902 12.0393 23.9256 12.5288 23.9256 11.0332C23.9256 7.77479 24.9276 7.63597 28.7744 7.63573C30.1896 7.63564 33.1969 7.54265 34.789 7.54266C36.1729 7.54266 37.6176 7.86786 39.3159 7.77479C40.6745 7.70033 41.0526 7.68247 41.8647 8.52014C43.0341 9.72622 42.8892 11.6847 42.8892 12.0562C42.8892 13.4989 42.9246 17.3615 42.9246 18.5715Z"
          fill="#0E273F"
          stroke="#0E273F"
          strokeWidth="1.21633"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.4233 19.9348C41.4233 20.8402 41.3877 23.2536 41.3877 23.8962C41.3876 26.7801 32.3499 26.2801 32.3499 26.2801C32.3499 26.2801 22.8499 26.2801 22.6192 24.9409C22.3928 23.6271 22.2631 21.1516 22.2631 19.8296L22.2631 15.1463C22.2631 13.8245 22.2987 14.2824 22.2987 12.8833C22.2987 9.83537 23.3073 9.70552 27.1795 9.70529C28.6041 9.70521 31.6313 9.61823 33.2339 9.61823C34.6269 9.61823 36.0812 9.92243 37.7907 9.83537C39.1582 9.76572 39.5389 9.74901 40.3564 10.5326C41.5335 11.6608 41.3877 13.4928 41.3877 13.8403C41.3877 15.1898 41.4233 18.803 41.4233 19.9348Z"
          fill="#F7FBFD"
          stroke="#0E273F"
          strokeWidth="0.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.0977 9.80709C43.0952 9.81297 43.0918 9.82451 43.0871 9.84461C42.9916 10.2584 42.7544 10.3553 42.2962 10.5402C41.5673 10.8344 41.2617 10.7649 41.1325 10.7649C40.9118 10.7649 40.4175 10.8691 40.2064 10.8691C39.9952 10.8691 39.8654 10.8515 39.376 10.8691C38.8865 10.8867 38.2507 11.0818 38.0295 10.7649C37.8629 10.5261 37.9815 9.97285 37.9432 9.71764C37.9048 9.46243 37.9336 9.08401 37.9336 8.78481C37.9336 8.5176 37.9432 8.61017 37.9432 8.32734C37.9432 7.71117 38.215 7.68492 39.2584 7.68488C39.6423 7.68486 39.3597 7.56231 39.7915 7.56231C40.1669 7.56231 40.7079 7.48205 41.2287 7.64627C41.7721 7.81758 42.6182 8.0944 42.8385 8.25281C43.1557 8.48088 43.0871 8.95224 43.0871 9.0225C43.0871 9.29531 43.0967 9.52404 43.0967 9.75284C43.0967 9.77774 43.0971 9.7952 43.0977 9.80709C43.1006 9.86893 43.1088 9.78066 43.0977 9.80709Z"
          fill="#0E273F"
        />
        <path
          d="M43.0871 9.84461C43.1167 9.71661 43.0967 9.93589 43.0967 9.75284C43.0967 9.52404 43.0871 9.29531 43.0871 9.0225C43.0871 8.95224 43.1557 8.48088 42.8385 8.25281C42.6182 8.0944 41.7721 7.81758 41.2287 7.64627C40.7079 7.48205 40.1669 7.56231 39.7915 7.56231C39.3597 7.56231 39.6423 7.68486 39.2584 7.68488C38.215 7.68492 37.9432 7.71117 37.9432 8.32734C37.9432 8.61017 37.9336 8.5176 37.9336 8.78481C37.9336 9.08401 37.9048 9.46243 37.9432 9.71764C37.9815 9.97285 37.8629 10.5261 38.0295 10.7649C38.2507 11.0818 38.8865 10.8867 39.376 10.8691C39.8654 10.8515 39.9952 10.8691 40.2064 10.8691C40.4175 10.8691 40.9118 10.7649 41.1325 10.7649C41.2617 10.7649 41.5673 10.8344 42.2962 10.5402C42.7544 10.3553 42.9916 10.2584 43.0871 9.84461Z"
          stroke="#0E273F"
          strokeWidth="1.21633"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.453 9.6791C41.453 9.91412 41.5342 10.543 41.414 10.7073C41.0254 11.2385 39.2297 11.182 37.5901 11.2159C35.2087 11.2159 33.3918 11.2046 32.8663 11.2046C31.9684 11.2046 30.6411 11.2498 29.7823 11.2498C28.9234 11.2498 28.4159 11.2272 26.4249 11.2498C24.4339 11.2724 21.577 11.5342 20.8404 10.9785C20.489 10.7134 20.489 10.1263 20.489 9.6339C20.489 9.28684 20.45 8.82036 20.45 8.43622C20.45 8.09313 20.489 8.21199 20.489 7.84885C20.489 7.05775 21.5947 7.02404 25.8393 7.02398C27.4009 7.02396 30.7192 7.00139 32.476 7.00139C34.003 7.00139 35.5971 7.08034 37.471 7.05775C38.9701 7.03967 39.3874 7.03533 40.2835 7.23871C41.5738 7.53154 41.414 8.00704 41.414 8.09725C41.414 8.44751 41.453 9.38533 41.453 9.6791Z"
          fill="#F7FBFD"
          stroke="#0E273F"
          strokeWidth="0.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.3701 8.68167C25.5263 8.53317 23.0362 8.29158 24.302 5.61856C25.3985 3.30303 28.3767 4.86698 28.1915 6.53765"
          stroke="#0E273F"
          strokeWidth="0.9"
          strokeLinecap="round"
        />
        <path
          d="M35.6002 8.54804C34.8253 8.95414 32.5982 8.54812 33.2892 5.73333C33.918 3.17189 37.5498 4.95036 37.3562 6.69079"
          stroke="#0E273F"
          strokeWidth="0.9"
          strokeLinecap="round"
        />
        <path
          d="M36.9915 21.5539C27.0373 27.5658 22.6339 18.0005 27.396 14.6338C32.1581 11.2671 36.7549 14.9043 36.4573 18.0907C36.3664 19.0634 36.3047 19.3753 35.7679 20.3515"
          stroke="#0E273F"
          strokeWidth="0.9"
          strokeLinecap="round"
        />
        <path
          d="M29.6708 19.4712H30.6856V17.109C30.4774 17.206 30.2432 17.2941 29.905 17.4175L29.4279 16.1747L31.2928 15.593H32.1601V19.4712H32.8801V20.8814H29.6708V19.4712Z"
          fill="#0E273F"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_9558_145"
          x="-0.150085"
          y="-0.719971"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="12"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_9558_145"
          />
          <feOffset dy="16" />
          <feGaussianBlur stdDeviation="16" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.105882 0 0 0 0 0.105882 0 0 0 0 0.105882 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9558_145"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_9558_145"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default FirstOfMonthCalendar;
